import RowItemDocumentDetail from './RowItemDocumentDetail.jsx';
import RowItemListGroupPeoPleDetailReception from './RowItemListGroupPeoPleDetailReception.jsx';

export {
  RowItemDocumentDetail,
  RowItemListGroupPeoPleDetailReception
};



// WEBPACK FOOTER //
// ./src/components/modules/reception/datatable/detail/index.js